<template>
  <div>
	  <a class="font12" @click="viewHelp">{{text || '帮助'}} <i class="el-icon-question font16 "></i></a>
	  
	  <el-drawer
	    title="帮助文档"
		:direction="direction"
		:append-to-body="true"
	    :visible.sync="drawer"
	  	:size="size"
	    >
	  	<div v-loading 	class="drawerBox">
			<div v-html="content"></div>
		</div>
	  </el-drawer>
  </div>
</template>

<script>
import { helpPopovereApi } from '@/api/common';	
export default {
  props: {
	code:'',
	text:'',
	direction:{
		type:String,
		default:'ttb'
	},
	size:{
		type:Number,
		default:500
	},
  },
  data(){
	return {
		content:'',
		loading:false,
		drawer:false,
	}  
  },
  watch:{
    
  },
  computed: {
  },
  mounted() {
  },
  methods: {
	viewHelp()
	{
		this.drawer = true;
		this.load()
	},
	load()
	{
		this.loading = true;
		helpPopovereApi(this.code).then((res) => {
		  this.content = res.data.tpl;
		  this.loading = false;
		  
		});
	},
	
  },
};
</script>

<style scoped>
	
.drawerBox{
	padding: 20px;
}
</style>
